import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        await exchangeGoogleSession(sessionId);
        // Clean URL hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/feed", { replace: true });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-black">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto rounded-full border-2 border-pink-500/40 border-t-pink-500 animate-spin" />
        <p className="mt-4 text-zinc-400 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
